import { useLazyQuery } from '@apollo/client';
import { EuiFormLabel, EuiComboBox, EuiComboBoxOptionOption } from '@elastic/eui';
import { PROVINCES } from 'apollo-client/queries/getAvailableProvinces';
import { provinces } from 'cache';
import { Query, QueryGetAvailableProvincesArgs } from 'generated/graphql';
import { useLocalCache } from 'hooks/useLocalCache';
import { useIntl } from 'react-intl';

import * as S from './FiltersSidebar.styles';

export const ProvinceFilter = ({ isDisabled }: { isDisabled?: boolean }): JSX.Element => {
  const { formatMessage } = useIntl();
  const localFilters = useLocalCache();
  const [onGetAvailableProvinces, { loading, data }] = useLazyQuery<Query, QueryGetAvailableProvincesArgs>(PROVINCES, {
    fetchPolicy: 'network-only',
  });

  return (
    <S.SidebarFilterWrapper>
      <EuiFormLabel>{formatMessage({ id: 'filters.province.label' })}</EuiFormLabel>
      <EuiComboBox
        async
        isDisabled={isDisabled}
        isLoading={loading}
        placeholder={formatMessage({ id: 'filters.province.placeholder' })}
        options={data?.getAvailableProvinces?.map((x: string) => ({ label: x, value: x })) ?? []}
        selectedOptions={localFilters?.data?.provinces?.map((x: string) => ({ label: x, value: x }))}
        onSearchChange={(e: string): void => {
          onGetAvailableProvinces({
            variables: {
              inputProvince: e,
              inputRegions: localFilters?.data?.regions,
              inputCountry: localFilters?.data?.country,
            },
          });
        }}
        onClick={(): void => {
          onGetAvailableProvinces({
            variables: {
              inputProvince: '',
              inputRegions: localFilters.data?.regions,
              inputCountry: localFilters?.data?.country,
            },
          });
        }}
        onChange={(x: EuiComboBoxOptionOption<string>[]): void => {
          provinces(x?.map(({ value }) => value) as string[]);
        }}
      />
    </S.SidebarFilterWrapper>
  );
};
